import { AxiosInstance } from 'axios';
import ResTable from 'models/api/table';
import {
    ExtendedTariffSchedule,
    TariffAdd,
    TariffPeriodProceduresParam,
    TariffsFilter,
    TariffsInfo,
    TariffsTable,
    TariffUpdate,
    TariffUpdatePartial,
} from 'models/api/tariff';
import { Key } from 'react';
import { DropDown } from '@finbeat/react-toolkit';

export const getTariffs = async (axios: AxiosInstance, params: TariffsFilter) => {
    const { data } = await axios.get<ResTable<TariffsTable>>('/Tariffs', {
        params: { ...params },
    });
    return data;
};

export const getTariffsItem = async (axios: AxiosInstance, id: Key) => {
    const { data } = await axios.get<TariffsInfo>(`/Tariffs/${id}`);
    return data;
};

export const addTariff = async (axios: AxiosInstance, info: TariffAdd) => {
    const { data } = await axios.post<number>(`/Tariffs`, info);
    return data;
};

export const updateTariff = async (axios: AxiosInstance, info: TariffUpdate) => {
    await axios.put(`/Tariffs`, info);
};

export const updateTariffPartial = async (axios: AxiosInstance, info: TariffUpdatePartial) => {
    await axios.put(`/Tariffs/partialUpdate`, info);
};

export const deleteTariff = async (axios: AxiosInstance, id: Key) => {
    await axios.delete(`/Tariffs/${id}`);
};

export const getCoverGroupList = async (axios: AxiosInstance) => {
    const { data } = await axios.get<DropDown[]>(`/Tariffs/coverGroupList`);
    return data;
};

export const getProceduresDefList = async (axios: AxiosInstance) => {
    const { data } = await axios.get<DropDown[]>(`/Tariffs/proceduresDefList`);
    return data;
};

export const getParentServiceList = async (axios: AxiosInstance) => {
    const { data } = await axios.get<DropDown[]>(`/Tariffs/parentServiceList`);
    return data;
};

export const getTariffPlansList = async (axios: AxiosInstance) => {
    const { data } = await axios.get<DropDown[]>(`/Tariffs/plansList`);
    return data;
};

export const getServiceList = async (axios: AxiosInstance) => {
    const { data } = await axios.get<DropDown[]>(`/Tariffs/serviceList`);
    return data;
};

export const getProcedureParams = async (
    axios: AxiosInstance,
    periodId: Key,
    proceduresDefId: Key | null
) => {
    const { data } = await axios.get<TariffPeriodProceduresParam[]>(`/Tariffs/procedureParams`, {
        params: { periodId, proceduresDefId },
    });
    return data;
};

export const getSchedule = async (
    axios: AxiosInstance,
    id: Key | null,
    term: number | null,
    amount: number | null,
    apr: number | null
) => {
    const { data } = await axios.get<ExtendedTariffSchedule>(`/Tariffs/${id}/schedule`, {
        params: { term, amount, apr },
    });
    return data;
};

export const getTariffsExcel = async (axios: AxiosInstance, params?: TariffsFilter) => {
    const { data } = await axios.get<Blob>('/Tariffs/excel', {
        responseType: 'arraybuffer',
        params: { ...params },
    });
    return data;
};
